import axios from "axios";
import {signUrl} from './UrlSignatureModule';

export const fetchOverdueReleasedReplenishments = () => {
    const path = __API__ + '/api/ui/releasedreplenishment/overdue?workDays=5';
    return axios.get(path);
};

export const buildCsvDownloadUrl = (query, filters) => {

    const formatCreatedAfter = filters.createdAfter.utc().toISOString();

    const formatCreatedBefore = filters.createdBefore.utc().toISOString();

    const modules = filters.modulesSelected.join(',')

    const url = __API__ + `/api/ui/releasedreplenishment/csv?search=${query}&processingStatus=${filters.processingStatus}&propertyToSortBy=id&sortDirection=ASC&createdAfter=${formatCreatedAfter}&createdBefore=${formatCreatedBefore}&modules=${modules}`;

    return signUrl(url);
};

export const uploadShippingStatusUpdate = (file) => {
    const path = __API__ + '/api/sap/replenishment/shipping';

    const config = {
        validateStatus: (status) => status === 200,
    };

    let formData = new FormData();
    formData.append('file', file);

    return axios.put(path, formData, config);
};


// WEBPACK FOOTER //
// ./src/admin/services/ReplenishmentModule.js